import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2285a58a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-missing" }
const _hoisted_5 = { class: "text-missing" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_7 = ["title"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "text-missing" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: `/ico/support-blue.svg` }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "score-container" }
const _hoisted_16 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isPercentageShown)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.Lang.getI18N("yes")), 1)
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("span", null, _toDisplayString(`${_ctx.getAnswerPercentage(true)}%`), 1)
          ]),
          _hoisted_1
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.Lang.getI18N("no")), 1)
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("span", null, _toDisplayString(`${_ctx.getAnswerPercentage(false)}%`), 1)
          ]),
          _hoisted_2
        ]),
        (_ctx.hasEmptyQuestions)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Lang.getI18N("answer-missing")), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(`${
            100 -
            (Number(_ctx.getAnswerPercentage(false)) +
              Number(_ctx.getAnswerPercentage(true)))
          }%`), 1)
              ]),
              _hoisted_6
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.answers, (answer) => {
        return (_openBlock(), _createElementBlock("tr", {
          title: answer.getAuditorLabel(_ctx.state.stores!)
        }, [
          (answer.toPDF() === '')
            ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.Lang.getI18N("answer-missing")), 1)
              ]))
            : (_openBlock(), _createElementBlock("td", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(answer.toPDF() ? _ctx.Lang.getI18N("yes") : _ctx.Lang.getI18N("no")), 1)
              ])),
          _hoisted_11,
          _createElementVNode("td", null, [
            (answer.comment !== null)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "comments-container",
                  onClick: ($event: any) => (_ctx.showComment(answer))
                }, _hoisted_14, 8, _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("td", _hoisted_15, [
            (_ctx.question.score)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(`${answer.score}/${_ctx.question.score}`), 1))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_7))
      }), 256))
}